import type { MouseEvent, ReactNode } from 'react';
import { useFormat } from '@paige/format';
import type { CustomerRow } from './customer-types';
import {
  AttentionCell,
  HealthCell,
  LastActiveCell,
  NameCell,
  NextStepCell,
  PagesCell,
  type CompanyLink,
} from './customer-cells';
import './customers.css';

export interface CustomerCardsProps {
  rows: readonly CustomerRow[];
  today: string;
  onOpen: (id: string) => void;
  renderLink: CompanyLink;
}

function Card({ row, today, onOpen, renderLink }: { row: CustomerRow } & CustomerCardsProps) {
  const f = useFormat();
  const open = (e: MouseEvent<HTMLElement>): void => {
    if ((e.target as HTMLElement).closest('a, button') === null) onOpen(row.id);
  };
  return (
    <li className="ad-cu-card" onClick={open}>
      <div className="ad-cu-card__top">
        <NameCell row={row} renderLink={renderLink} />
        <HealthCell row={row} today={today} />
      </div>
      <dl className="ad-cu-card__facts">
        <div>
          <dt>Card money</dt>
          <dd>{f.money(row.paid)}</dd>
        </div>
        <div>
          <dt>Pages read</dt>
          <dd>
            <PagesCell row={row} />
          </dd>
        </div>
        <div>
          <dt>Last active</dt>
          <dd>
            <LastActiveCell row={row} />
          </dd>
        </div>
      </dl>
      <AttentionCell row={row} />
      <NextStepCell row={row} today={today} />
    </li>
  );
}

/** The same page of customers on a phone: a card a company, in the same order, never beside the table. */
export function CustomerCards(props: CustomerCardsProps): ReactNode {
  return (
    <ul className="ad-cu-cards">
      {props.rows.map((row) => (
        <Card key={row.id} row={row} {...props} />
      ))}
    </ul>
  );
}
